module.exports = __webpack_public_path__ + "img/dentistry.c7fa4d6.png";